import { instance } from "api/apiBase";
import type {
  FraudAlertsParams,
  FraudAlertsResponse,
  MonitoredPropertiesParams,
  MonitoredPropertiesResponse,
  PropertyMonitoringStatus,
  PropertyShieldIntegration
} from "api/propertyShield/types";

const INTEGRATION_PATH = "/portal/v1/property_shield/integration";

export const propertyShieldApi = {
  getFraudAlerts: (params: FraudAlertsParams = {}) =>
    instance
      .get<FraudAlertsResponse>("/portal/v1/property_shield/fraud_alerts", {
        params
      })
      .then((res) => res.data),

  getMonitoredProperties: (params: MonitoredPropertiesParams = {}) =>
    instance
      .get<MonitoredPropertiesResponse>(
        "/portal/v1/property_shield/properties",
        { params }
      )
      .then((res) => res.data),

  getMonitoringStatus: (propertyId: number) =>
    instance
      .get<PropertyMonitoringStatus>(
        `/portal/v1/property_shield/properties/${propertyId}/monitoring_status`
      )
      .then((res) => res.data),

  getIntegration: () =>
    instance
      .get<PropertyShieldIntegration>(INTEGRATION_PATH)
      .then((res) => res.data),

  connect: (name: string) =>
    instance
      .post<PropertyShieldIntegration>(INTEGRATION_PATH, { name })
      .then((res) => res.data),

  disconnect: () =>
    instance
      .delete<PropertyShieldIntegration>(INTEGRATION_PATH)
      .then((res) => res.data)
};
